import React, { useContext } from 'react';
import { bool, number, string } from 'prop-types';
import pathfinder from '@fiverr-private/pathfinder';
import { EventTypes } from '../../../../../../../../shared/utils/events/types';
import eventsReporter from '../../../../../../../../shared/utils/events/reporter';
import { redirectTo } from '../../../../../../../../shared/utils/redirect';
import Avatar from '../../../../../../../../shared/components/Avatar';
import SharedContext from '../../../../../../../../shared/context';
import { ROLLOUTS } from '../../../../../../shared/constants/rollouts';
import Headline from './Headline';
import Info from './Info';

import './style.scss';

const { sellerCard } = EventTypes.collectionPage;

const Profile = ({
    avatarClassName,
    username,
    achievement,
    profilePhoto,
    isPro,
    isUnavailable,
    rating,
    ratingCount,
    country,
    memberSince,
    responseTime,
    sellerLevel,
}) => {
    const { rollouts } = useContext(SharedContext);
    const { [ROLLOUTS.QUALAS_NEW_LEVEL_SYSTEM]: inNewLevelSystem } = rollouts;

    const onClick = () => {
        const sellerPageUrl = pathfinder('short_user', { id: username });

        eventsReporter.report(sellerCard.clicked);

        redirectTo(sellerPageUrl);
    };

    return (
        <section className="profile" onClick={onClick}>
            <Avatar
                className={avatarClassName}
                username={username}
                profilePhoto={profilePhoto}
                achievement={inNewLevelSystem ? undefined : achievement}
                isPro={isPro}
                isUnavailable={isUnavailable}
            />
            <Headline
                username={username}
                rating={rating}
                sellerLevel={inNewLevelSystem ? sellerLevel : undefined}
                ratingCount={ratingCount}
                isUnavailable={isUnavailable}
            />
            <Info country={country} memberSince={memberSince} responseTime={responseTime} />
        </section>
    );
};

Profile.propTypes = {
    avatarClassName: string,
    username: string,
    achievement: number,
    profilePhoto: string,
    isPro: bool,
    isUnavailable: bool,
    rating: number,
    ratingCount: number,
    country: string,
    memberSince: number,
    responseTime: number,
    sellerLevel: string,
};

export default Profile;
